import * as types from "@/store/types";
import { MarketMarketService } from "@/services";

const state = {
  currentCoin: null
};

const getters = {
  [types.marketExchange.getters.GET_CURRENT_COIN]: state => {
    return state.currentCoin;
  }
};

const mutations = {
  [types.marketExchange.mutations.MUTATE_CURRENT_COIN]: (state, payload) => {
    state.currentCoin = payload;
  }
};

const actions = {
  [types.marketExchange.actions.SET_CURRENT_COIN]: ({ commit }, payload) => {
    MarketMarketService.getSymbolInfo({ symbol: payload.symbol }).then(
      async res => {
        await commit(types.marketExchange.mutations.MUTATE_CURRENT_COIN, {
          ...res.data,
          ...payload
        });
      }
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
